function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.8 8C0.8 4.01988 4.02018 0.8 8 0.8C11.9801 0.8 15.2 4.02015 15.2 8C15.2 11.9801 11.9798 15.2 8 15.2C4.01988 15.2 0.8 11.9798 0.8 8Z",
  fill: "#E7EEFF",
  stroke: "#0D53FC",
  strokeWidth: 1.6
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0432 5.95726C11.2533 6.1673 11.2533 6.50778 11.0432 6.71772L7.43598 10.3251C7.22593 10.535 6.88556 10.535 6.67552 10.3251L4.95831 8.60779C4.74827 8.39785 4.74827 8.05737 4.95831 7.84743C5.16825 7.63739 5.50873 7.63739 5.71867 7.84743L7.05569 9.18446L10.2828 5.95726C10.4928 5.74732 10.8333 5.74732 11.0432 5.95726Z",
  fill: "#0D53FC",
  stroke: "#0D53FC",
  strokeWidth: 0.3
});

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.0d2b473e.svg";
export { ForwardRef as ReactComponent };